var chunkToChildrenMap = {
	"53087": [
		68449,
		35915,
		6209,
		6754,
		21222,
		90206,
		2096,
		43981,
		13902,
		55068,
		50256,
		89845,
		56700,
		89741,
		95605,
		53209
	],
	"89741": [
		52173,
		47976,
		10536,
		87599,
		52371,
		33958,
		83045,
		54751,
		41483,
		58299,
		77907,
		48685
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));